<template>
    <ion-card>
        <ion-grid
            @click="isExpanded = !isExpanded"
            class="c-expansion-card__header"
        >
            <ion-row class="ion-align-items-center">
                <ion-col>
                    <slot name="header"></slot>
                </ion-col>
                <ion-col size="auto">
                    <ion-icon
                        class="c-expansion-card__icon"
                        :name="iconName"
                    ></ion-icon>
                </ion-col>
            </ion-row>
        </ion-grid>
        <transition
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave"
            :css="false"
        >
            <div
                class="c-expansion-card__content"
                ref="content"
                v-show="isExpanded"
            >
                <slot></slot>
            </div>
        </transition>
    </ion-card>
</template>

<script>
export default {
    data() {
        return {
            isExpanded: false,
        };
    },
    mounted() {},
    methods: {
        beforeEnter: function (el) {
            el.style.height = "0px";
        },
        enter: function (el) {
            el.style.height = this.$refs.content.scrollHeight + "px";
            setTimeout(() => {
                if (this.isExpanded) {
                    el.style.height = null;
                }
            }, 250);
        },
        beforeLeave: function (el) {
            el.style.height = this.$refs.content.scrollHeight + "px";
        },
        // FIX: Animation doesnt work without done parameter
        // eslint-disable-next-line
        leave: function (el, done) {
            el.style.height = this.$refs.content.scrollHeight + "px";
            el.style.height = "0px";
        },
    },
    computed: {
        iconName() {
            let result = "arrow-dropdown";
            if (this.isExpanded) {
                result = "arrow-dropup";
            }
            return result;
        },
    },
};
</script>

<style lang="scss" scoped>
.c-expansion-card {
    &__header {
        cursor: pointer;
    }
    &__icon {
        width: 25px;
        height: 25px;
    }
    &__content {
        overflow: hidden;
        transition: all 0.25s ease-out;
    }
}
</style>
